<template>
  <el-dialog
    v-model="modelValue.dialogVisible"
    title="Токен авторизации"
    class="modal-95-70-60"
    @close="handleClose"
  >
    <pre style="font-weight: bold; font-size: 14px;" v-if="modelValue.token">{{modelValue.token}}</pre>
<!--      <remove-button-->
<!--          v-if="editingHttpAuthToken.token"-->
<!--          type="danger"-->
<!--          :table-button="true"-->
<!--          :loading="revokingToken"-->
<!--          :confirm-message="'Вы уверены, что хотите сбросить токен авторизации?\n'+-->
<!--'После сброса текущий токен перестанет работать, это действие невозможно отменить!'"-->
<!--          @confirm="revokeAuthToken"-->
<!--          style="margin-top: 50px"-->
<!--      >-->
<!--        Сбросить токен-->
     <!-- </remove-button> -->
    <el-button type="success" v-else @click="revokeAuthToken">Сгенерировать токен</el-button>
  </el-dialog>
</template>

<script>
export default {
  name: "TokenDialog",
  props: ["modelValue"],
  methods: {
    async revokeAuthToken(){
      this.revokingToken = true
      let resp = await this.axios.post(this.modelValue.revokeTokenPath, {userId: this.modelValue.userId}).catch(console.error)
      this.modelValue.token = resp.data
      this.$gNotify(`Новый токен авторизации сгенерирован`, "success")
      this.revokingToken = false
      this.$emit("refresh")
    },
    handleClose(){
      this.$emit("update:modelValue", {dialogVisible: false})
    }
  },
  data(){
    return {
      revokingToken: false
    }
  }
}
</script>